module.exports = __webpack_public_path__ + "img/Jd.4dc14e46.png";